import type { Permission } from '../types/Permission';

export function hasPermission(permissions: Permission[], permission: string): boolean {
  return typeof permissions.find(p => p.name == permission) !== 'undefined';
}